module.exports = __webpack_public_path__ + "static/media/21ECLAC25.bdc26a0a.jpg";